import { FaCircleInfo } from "react-icons/fa6";
import { Center } from "../../../../styled-system/jsx";
import ShelfForm from "./ShelfForm";

const ShelfDetails = ({
  data,
  selectedShelf,
  brandData,
  categoryFilter,
  updateShelfData,
  numOfShelfCredits,
  numOfShelves,
  fullLayout,
  setCategoryFilter,
}) => {
  const selectedShelfData = data.find((shelf) => shelf.id === selectedShelf);
  const shelfStatus = selectedShelfData?.stats?.status;

  return selectedShelf !== null ?
      <>
        {shelfStatus === "in_progress" && (
          <Center colot="text.secondary" fontSize={"xlarge"}>
            <FaCircleInfo /> Your shelf is currently being created. Please allow up to 24 hours for shelf data to be
            populated.
          </Center>
        )}
        {selectedShelfData && (
          <ShelfForm
            data={selectedShelfData}
            key={selectedShelfData?.id}
            brandData={brandData}
            categoryFilter={categoryFilter ?? selectedShelfData?.category}
            updateShelfData={updateShelfData}
          />
        )}
      </>
    : <div style={{ minHeight: "70vh" }}>
        <ShelfForm
          create
          data={data}
          brandData={brandData}
          categoryFilter={categoryFilter}
          updateShelfData={updateShelfData}
          numOfShelfCredits={numOfShelfCredits}
          numOfShelves={numOfShelves}
          fullLayout={fullLayout}
          setCategoryFilter={setCategoryFilter}
        />
      </div>;
};

export default ShelfDetails;
